export const UPDATE_COLUMN_ITEM_CONTENT = 'columnItemTypes/UPDATE_COLUMN_ITEM_CONTENT';
export const REFRESH_COLUMN_ITEM_CONTENT = 'columnItemTypes/REFRESH_COLUMN_ITEM_CONTENT';
export const ADD_NEW_ITEM_FROM_PLACEHOLDER_TO_COLUMN = 'columnItemTypes/ADD_NEW_ITEM_FROM_PLACEHOLDER_TO_COLUMN';
export const MOVE_COLUMN_ITEM_CONTENT_TO_ANOTHER_COLUMN = 'columnItemTypes/MOVE_COLUMN_ITEM_CONTENT_TO_ANOTHER_COLUMN';
export const DUPLICATE_COLUMN_ITEM = 'columnItemTypes/DUPLICATE_COLUMN_ITEM';
export const DELETE_COLUMN_ITEM = 'columnItemTypes/DELETE_COLUMN_ITEM';
export const ADD_NEW_COLUMN_ITEM = 'columnItemTypes/ADD_NEW_COLUMN_ITEM';
export const UPDATE_COLUMN_ITEM_CONTENT_IN_MULTIPLE_BLOCKS = 'columnItemTypes/UPDATE_COLUMN_ITEM_CONTENT_IN_MULTIPLE_BLOCKS';
export const UPDATE_COLUMN_ITEM_FONT_IN_MULTIPLE_BLOCKS = 'columnItemTypes/UPDATE_COLUMN_ITEM_FONT_IN_MULTIPLE_BLOCKS';
export const OVERRIDE_COLUMN_ITEM = 'columnItemTypes/OVERRIDE_COLUMN_ITEM';
